import React, { memo } from 'react';
import * as styles from './LinkCardV1.module.scss';
import RedNumberText from '../../RedNumberText/RedNumberText';
import { PLATFORM_BG_COLOR_MAP } from '../../../constants';
import LinkDisclaimer from '../../LinkDisclaimer/LinkDisclaimer';
import { useLinkCard } from '../hooks/useLinkCard';

const LinkCardV1 = ({ linkData, creatorName, disableDeeplinks = false }) => {
  const {
    isDisclaimerVisible,
    isInstagram,
    didNavigationSilentBlock,
    closeDisclaimer,
    platformIcon,
    CardWrapper,
  } = useLinkCard({
    ...linkData,
    url: linkData.link,
    creatorName,
    disableDeeplinks,
    customIconClassName: styles.customLinkIcon,
  });

  const { platform, platformTitle, link, withSensitiveLinkHoldToOpen } =
    linkData;

  return (
    <CardWrapper buttonClassName={styles.linkButton}>
      <div
        className={styles.linkCard}
        style={{
          backgroundColor: PLATFORM_BG_COLOR_MAP[platform],
          cursor: isDisclaimerVisible ? 'default' : 'pointer',
        }}
      >
        {isDisclaimerVisible && (
          <LinkDisclaimer
            url={link}
            disableDeeplinks={disableDeeplinks}
            showExternalBrowserInstructions={
              !disableDeeplinks || didNavigationSilentBlock
            }
            creatorName={creatorName}
            onClose={closeDisclaimer}
            withSensitiveLinkHoldToOpen={withSensitiveLinkHoldToOpen}
          />
        )}

        {(isInstagram || !isDisclaimerVisible) && (
          <>
            <div className={styles.linkCardIcon}>{platformIcon}</div>
            <p className={styles.linkCardTitle}>
              <RedNumberText {...platformTitle} />
            </p>
          </>
        )}
      </div>
    </CardWrapper>
  );
};

export default memo(LinkCardV1);
